export default __webpack_public_path__ + "files/Roadmap_Lviv_Region.docx";